import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PersonStatus } from 'src/app/people/models/personStatus';

@Component({
  selector: 'bulk-update-status-workspaces-modal',
  templateUrl: './bulk-update-status-workspaces-modal.component.html',
  styleUrls: ['./bulk-update-status-workspaces-modal.component.scss'],
  standalone: false
})
export class BulkUpdateStatusWorkspacesModalComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<BulkUpdateStatusWorkspacesModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
  bulkUpdate: boolean = false;
  status: PersonStatus = PersonStatus.Archived;
  ngOnInit(): void {
    this.bulkUpdate = this.data?.bulkUpdate;
    if (this.data?.status) {
      this.status = this.data.status;
    }
  }

  public update() {
    this.dialogRef.close(true);
  }

  public updateInOrg() {
    this.dialogRef.close(false);
  }

  public cancel() {
    this.dialogRef.close(null);
  }
}
